module.exports = __webpack_public_path__ + "img/GU.851bfab2.svg";